<div class="px-1 py-1 space-y-1 text-center">
    <div>
        @if (active_account()) {
        <app-widget-box name="Chat Box" description="Join the discussion" [dark]="true">
            <div>
                <app-widget-button (clicked)="send()" heading="Send Message">
                </app-widget-button>
            </div>
        </app-widget-box>
        }
        @else {
        <app-widget-box name="Chat Box" description="Connect your wallet to join the discussion" [dark]="true">
            <div>
                <app-widget-button (clicked)="openWallet()" heading="Connect Wallet">
                </app-widget-button>
            </div>
        </app-widget-box>
        }
    </div>
    @for (sent of event_sents(); track $index) {
    <div>
        <app-widget-box [dark]="true">
            <div>
                <p class="text-green-600">
                    {{sent.account | address}}
                </p>
                <p class="whitespace-pre-wrap">{{sent.message}}</p>
            </div>
        </app-widget-box>
    </div>
    }
</div>